import { forwardRef } from 'react';
import TextInput, { type TextInputProps } from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { useTranslation } from 'react-i18next';

import s from './PasswordInput.scss';

export interface Props extends TextInputProps {
  strength?: 'weak' | 'normal' | 'strong';
}

const PasswordInput = forwardRef<HTMLInputElement, Props>(({ strength, ...restProps }, ref) => {
  let suffix;
  const { t } = useTranslation();
  if (strength) {
    suffix = (
      <span className={s[`strength-${strength}`]}>
        {t(`join.form.password.strength.${strength}`)}
      </span>
    );
  }
  return <TextInput type="password" {...restProps} postfix={suffix} ref={ref} />;
});
PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
